import defaultEpaperImage from "@assets/epaper/EpaperImage.svg";
import Image from "@elements/ResponsiveImage/Image";
import { EPAPER_LINK } from "@helper/getEnvVariables";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type EpaperBannerProps = {
  className?: string;
  epaperCoverImageUrl?: string;
};

export default function EpaperBanner({
  className,
  epaperCoverImageUrl,
}: EpaperBannerProps) {
  return (
    <>
      <div id="epaper-banner" className={twMerge("xl:mx-auto", className)}>
        <Link
          reloadDocument
          to={EPAPER_LINK}
          target="_blank"
          rel="noreferrer"
          className="block max-w-[320px] md:min-w-[198px] xmd:max-w-[230px] lg:min-w-[230px] lg:max-w-[270px] lg:w-full px-xs xmd:px-4 py-4 xmd:py-6.5 lg:py-[19.8px] bg-white"
        >
          <Image
            objectFit="initial"
            src={epaperCoverImageUrl ? epaperCoverImageUrl : defaultEpaperImage}
            className="mx-auto w-[288px] md:w-[198px] lg:w-[234px] h-[363px] md:h-[259px] lg:h-[316px]"
            srcWidth={266}
            srcHeight={355}
            alt="epaper-banner"
            dataTestId="image"
          />
        </Link>
        <div className="mx-4 bottom-4 relative ">
          <Link
            reloadDocument
            to={EPAPER_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex w-full h-xxs bg-yellow-100 items-center justify-center text-sm font-bold leading-4 xmd:leading-5 font-opensans border-0 py-1"
          >
            Read our ePaper
          </Link>
        </div>
      </div>
    </>
  );
}
